import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verifica se o consentimento já foi dado
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setIsVisible(true); 
    }
  }, []);

  const handleAccept = () => {
    // Salva o consentimento no localStorage
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false); 
  };

  if (!isVisible) return null; 

  return (
    <div
      style={{
        backgroundColor: "#ffffff", 
        color: "#7a9d8b", 
        padding: "15px",
        position: "fixed",
        bottom: "0",
        width: "100%",
        zIndex: "1000",
        fontFamily: "'TT Fors', sans-serif",
        boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)",
      }}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <p style={{ margin: "0", fontSize: "14px" }}>
          Este site utiliza cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa{" "}
          <Link to="/politica-de-privacidade" style={{ color: "#5a7d6b", fontWeight: "600", textDecoration: "underline" }}>
            Política de Privacidade
          </Link>.
        </p>
        <button
          onClick={handleAccept}
          style={{
            backgroundColor: "#7a9d8b", 
            color: "#ffffff", 
            border: "none",
            borderRadius: "5px",
            padding: "5px 15px",
            fontSize: "14px",
            cursor: "pointer",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          Aceitar
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
